import { postData } from "./axiosConfig"

export const contactUs = async (body) => {
    return await postData("/contact/store", body)
}